module.exports = __webpack_public_path__ + "static/media/slider-imgyomi1.2800d148.png";